import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { fetchGiveawayByShort } from "../api/client.js";

export default function ShortGiveawayRedirect() {
  const { code } = useParams();
  const [targetId, setTargetId] = useState(undefined);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const g = await fetchGiveawayByShort(code);
        if (!cancelled) setTargetId(g?.id || null);
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [code]);

  if (failed || targetId === null) return <Navigate to="/" replace />;
  if (targetId) return <Navigate to={`/giveaway/${targetId}`} replace />;
  return <p style={{ padding: 16, color: "var(--text-muted)" }}>Загрузка…</p>;
}
